import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";



export default function SliderHomeTestimonials() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 5500,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@0.75': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@1.00': {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                    '@1.50': {
                        slidesPerView: 3,
                        spaceBetween: 50,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper container"
            >


                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="3 / 5"  data-swiper-slide-index={2}>
                        <div className="testimonial-item">
                            <div className="testimonial-quote">
                                <img src="assets/images/testimonial-quote.svg" alt />
                            </div>
                            <div className="testimonial-rating">
                                <i className="fa-solid fa-star" />
                                <i className="fa-solid fa-star" />
                                <i className="fa-solid fa-star" />
                                <i className="fa-solid fa-star" />
                                <i className="fa-solid fa-star" />
                            </div>
                            <div className="testimonial-content">
                                <p>"I have been using CND Super Food Mahua Shakti Blend regularly, and I can feel a noticeable improvement in my daily energy levels. The taste is natural and the quality feels truly premium."</p>
                            </div>
                            <div className="author-info">
                                <div className="author-image">
                                    <figure className="image-anime">
                                        <img src="assets/img/Profile.png" alt />
                                    </figure>
                                </div>
                                <div className="author-content">
                                    <h3>Mr. Ravi Sharma</h3>
                                    <p>Happy Customer</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>

                <SwiperSlide>
                    <div className="swiper-slide" role="group" aria-label="4 / 5"  data-swiper-slide-index={3}>
                        <div className="testimonial-item">
                            <div className="testimonial-quote">
                                <img src="assets/images/testimonial-quote.svg" alt />
                            </div>
                            <div className="testimonial-rating">
                                <i className="fa-solid fa-star" />
                                <i className="fa-solid fa-star" />
                                <i className="fa-solid fa-star" />
                                <i className="fa-solid fa-star" />
                                <i className="fa-solid fa-star" />
                            </div>
                            <div className="testimonial-content">
                                <p>"I was looking for a natural health supplement without artificial ingredients. Mahua Shakti Blend combines traditional nutrition with excellent packaging and quality standards."</p>
                            </div>
                            <div className="author-info">
                                <div className="author-image">
                                    <figure className="image-anime">
                                        <img src="assets/img/Profile.png" alt />
                                    </figure>
                                </div>
                                <div className="author-content">
                                    <h3>Mr. Amit Patel</h3>
                                    <p>Happy Customer</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-prev" role="group" aria-label="5 / 5"  data-swiper-slide-index={4}>
                        <div className="testimonial-item">
                            <div className="testimonial-quote">
                                <img src="assets/images/testimonial-quote.svg" alt />
                            </div>
                            <div className="testimonial-rating">
                                <i className="fa-solid fa-star" />
                                <i className="fa-solid fa-star" />
                                <i className="fa-solid fa-star" />
                                <i className="fa-solid fa-star" />
                                <i className="fa-solid fa-star" />
                            </div>
                            <div className="testimonial-content">
                                <p>"Unlike many health products, this one tastes really good. I enjoy adding it to milk and smoothies, and it keeps me feeling active and energized."</p>
                            </div>
                            <div className="author-info">
                                <div className="author-image">
                                    <figure className="image-anime">
                                        <img src="assets/img/Profile.png" alt />
                                    </figure>
                                </div>
                                <div className="author-content">
                                    <h3>Mr. Suresh Yadav</h3>
                                    <p>Happy Customer</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="1 / 5"  data-swiper-slide-index={0}>
                        <div className="testimonial-item">
                            <div className="testimonial-quote">
                                <img src="assets/images/testimonial-quote.svg" alt />
                            </div>
                            <div className="testimonial-rating">
                                <i className="fa-solid fa-star" />
                                <i className="fa-solid fa-star" />
                                <i className="fa-solid fa-star" />
                                <i className="fa-solid fa-star" />
                                <i className="fa-solid fa-star" />
                            </div>
                            <div className="testimonial-content">
                                <p>"The blend contains premium ingredients like Mahua, dry fruits, and seeds, which makes it a complete nutritional option. I trust CND Super Food for its purity and authenticity."</p>
                            </div>
                            <div className="author-info">
                                <div className="author-image">
                                    <figure className="image-anime">
                                        <img src="assets/img/Profile.png" alt />
                                    </figure>
                                </div>
                                <div className="author-content">
                                    <h3>Mr. Rahul Sharma</h3>
                                    <p>Happy Customer</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-next" role="group" aria-label="2 / 5"  data-swiper-slide-index={1}>
                        <div className="testimonial-item">
                            <div className="testimonial-quote">
                                <img src="assets/images/testimonial-quote.svg" alt />
                            </div>
                            <div className="testimonial-rating">
                                <i className="fa-solid fa-star" />
                                <i className="fa-solid fa-star" />
                                <i className="fa-solid fa-star" />
                                <i className="fa-solid fa-star" />
                                <i className="fa-solid fa-star" />
                            </div>
                            <div className="testimonial-content">
                                <p>"The quality of Mahua Shakti Blend is outstanding. It reminds me of the traditional nutritious foods we grew up with but in a convenient modern format. I love that it's natural, healthy, and suitable for the whole family."</p>
                            </div>
                            <div className="author-info">
                                <div className="author-image">
                                    <figure className="image-anime">
                                        <img src="assets/img/Profile.png" alt />
                                    </figure>
                                </div>
                                <div className="author-content">
                                    <h3>Mr. Sandeep Mishra</h3>
                                    <p>Happy Customer</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
            </Swiper>
        </>
    );
}
